import { User } from "./user";

export class Company {
    private _name:string;
    private _email:string;
    private _user:User;
	private _id:number;
	private _clientCount:number;
	private _tokenCount:number;
	private _hostSiteName:string;
	private _sharedTokens:boolean;
    private _sendAssessmentsCompleteNotifications:boolean;
	private _sendNotificationsToPrimaryContact:boolean;
	private _disableShopRegisteredUsers:boolean;
	private _sendNotificationsCopyToRegularUsers:boolean;

    constructor(name?: string, email?: string, user?: User) {
        this.name = name;
        this.email = email ? email.toLowerCase() : "";
        if (!user) {
            this.user = new User();
        }
	}

	public get sharedTokens() : boolean {
		return this._sharedTokens;
	}
	
	public get hostSiteName() : string {
		return this._hostSiteName;
	}

	public get name(): string {
		return this._name;
	}

	public set name(value: string) {
		this._name = value;
	}

	public get email(): string {
		return this._email;
	}

	public set email(value: string) {
		this._email = value ? value.toLowerCase() : "";
	}

	public get user(): User {
		return this._user;
	}

	public set user(value: User) {
		this._user = value;
	}

	public get id(): number {
		return this._id;
	}

	public set id(value: number) {
		this._id = value;
	}

	public get clientCount() : number {
		return this._clientCount;
	}
	public get tokenCount() : number {
		return this._tokenCount;
	}

	public get sendAssessmentsCompleteNotifications() {
		return this._sendAssessmentsCompleteNotifications;
	}

	public set sendAssessmentsCompleteNotifications(v:boolean) {
		this._sendAssessmentsCompleteNotifications = v;
	}
      
    public get sendNotificationsToPrimaryContact() {
		return this._sendNotificationsToPrimaryContact;
	}

	public set sendNotificationsToPrimaryContact(v:boolean) {
		this._sendNotificationsToPrimaryContact = v;
	}

	public get disableShopRegisteredUsers() {
		return this._disableShopRegisteredUsers;
	}

	public set disableShopRegisteredUsers(v:boolean) {
		this._disableShopRegisteredUsers = v;
	}

	public get sendNotificationsCopyToRegularUsers() {
		return this._sendNotificationsCopyToRegularUsers;
	}

	public set sendNotificationsCopyToRegularUsers(v:boolean) {
		this._sendNotificationsCopyToRegularUsers = v;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/models/company.ts